export default "__VITE_ASSET__CkKCjN8g__"